module.exports = __webpack_public_path__ + "static/media/refund_application.0a852b0f.doc";